import { useGetIntakeNoteComprehensivePatientDataQuery } from './getIntakeNoteComprehensivePatientData.generated'

export function useGetIntakeNoteComprehensivePatientData(uid: string) {
  const { data, refetch, loading } = useGetIntakeNoteComprehensivePatientDataQuery({
    variables: { uid },
    fetchPolicy: 'cache-and-network',
  })
  return { data: data?.intakeNoteComprehensivePatientData, refetch, loading }
}
